
  import { Integration } from '@/services/integrations/types';
  import { useIntegrationsHomeStore } from '@/stores/integrationsHome';
  import { Icon } from '@/ui/components/icon/Icon';
  import { defineComponent } from 'vue';
  import { InputField } from '@/ui/components/form';

  interface NavbarHomeProps {
    integration: Integration;
  }

  export default defineComponent<NavbarHomeProps>({
    name: 'NavbarHome',
    components: {
      Icon,
      InputField,
    },
    props: ['integration'],
    setup() {
      const store = useIntegrationsHomeStore();

      return {
        store,
      };
    },
  });
